import { Button, Modal, TextInput } from 'flowbite-react';
import Select from 'react-select';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';
import { DeliveryItem } from '../../../Models/DeliveryItem';
import DeliveryApi from '../../../Api/DeliveryApi';
import ClientApi from '../../../Api/ClientApi';
import { ClientLocationAsset } from '../../../Models/ClientLocationAsset';
import { HiPlus } from 'react-icons/hi';
import ClientLocationAssetModal from '../../Client/ClientLocationAssetModal';
import { useAppDispatch, useAppSelector } from '../../../Reducers/store';
import { fetchInventoryTypes } from '../../../Actions/CommonFields';

export default function DeliveryItemModal({
  show,
  setShow,
  deliveryId,
  locationId,
  getDeliveryItems,
  getSchedulerData = undefined,
  selectedDeliveryItem,
  setSelectedDeliveryItem,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  deliveryId: number;
  locationId: number;
  getDeliveryItems: () => Promise<void> | undefined;
  getSchedulerData?: () => void;
  selectedDeliveryItem: DeliveryItem | null;
  setSelectedDeliveryItem: React.Dispatch<
    React.SetStateAction<DeliveryItem | null>
  >;
}) {
  const { inventoryTypes } = useAppSelector((state) => state.commonFields);
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [clientLocationAssetList, setclientLocationAssetList] = useState<
    ClientLocationAsset[]
  >([]);
  const [showAddNewLocationAssetModal, setshowAddNewLocationAssetModal] =
    useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const options = clientLocationAssetList.map((item) => ({
    value: item.id,
    label: item.number,
  }));
  const inventoryListOptions = inventoryTypes.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const [formData, setFormData] = useState<DeliveryItem>({
    id: 0,
    deliveryId: deliveryId,
    dateOrdered: null,
    quantity: null,
    price: null,
    clientLocationAssetId: null,
    defService: null,
    defQuantity: 0,
    qbitemId: null,
    description: null,
    defPrice: null,
    inventoryTypeId: null,

    clientLocationAsset: null,
    inventoryType: null,
    qbitem: null,
  });

  const getReferences = async () => {
    getAssetsForClientLocation(0);
    if (!inventoryTypes.length) {
      await Promise.all([dispatch(fetchInventoryTypes())]);
    }
  };

  const getAssetsForClientLocation = (assetId: number) => {
    try {
      return ClientApi.getAssetsForClientLocation(locationId)
        .then((res) => {
          setclientLocationAssetList(res.data);
          if (assetId > 0) {
            const asset = clientLocationAssetList.find((x) => x.id == assetId);
            setFormData((prevData) => ({
              ...prevData,
              clientLocationAssetId: assetId,
              inventoryTypeId: asset?.fuelInventoryTypeId ?? 1,
            }));
            setFormData((prevData) => ({
              ...prevData,
              clientLocationAssetId: assetId,
            }));
          }
        })
        .catch((err) => {
          toast.error('Error');
        });
    } catch (error) {
      console.error(error);
      toast.error('Error');
    }
  };

  useEffect(() => {
    getReferences();
  }, [selectedDeliveryItem]);

  const handleSetInitialValues = () => {
    const values = selectedDeliveryItem
      ? {
          ...selectedDeliveryItem,
        }
      : {
          id: 0,
          deliveryId: deliveryId,
          dateOrdered: null,
          quantity: null,
          price: null,
          clientLocationAssetId: null,
          defService: null,
          defQuantity: 0,
          qbitemId: null,
          description: null,
          defPrice: null,
          inventoryTypeId: null,

          clientLocationAsset: null,
          inventoryType: null,
          qbitem: null,
        };
    setFormData(values as DeliveryItem);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [selectedDeliveryItem]);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      deliveryId: deliveryId,
      dateOrdered: null,
      quantity: null,
      price: 0,
      clientLocationAssetId: null,
      defService: false,
      defQuantity: 0,
      qbitemId: null,
      description: null,
      defPrice: null,
      inventoryTypeId: null,

      clientLocationAsset: null,
      inventoryType: null,
      qbitem: null,
    };
    setFormData(values as DeliveryItem);
    setButtonDisabled(false);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeSelect = async (selectedOption) => {
    const { value } = selectedOption;
    const asset = clientLocationAssetList.find((x) => x.id == Number(value));
    setFormData((prevData) => ({
      ...prevData,
      clientLocationAssetId: parseInt(value),
      inventoryTypeId: asset?.fuelInventoryTypeId ?? 1,
    }));
  };

  const handleChangeSelectItem = async (selectedOption) => {
    const { value } = selectedOption;
    setFormData((prevData) => ({
      ...prevData,
      inventoryTypeId: parseInt(value),
    }));
  };
  const customStyles = {
    control: (base, state) => ({
      ...base,
      width: 300, // Set the width here
    }),
  };

  function cleanMoneyValues(formData: DeliveryItem) {
    formData.price = Number((formData.price ?? 0).toString().replace(',', ''));
  }
  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    cleanMoneyValues(formData);
    return await DeliveryApi.addUpdateDeliveryItem(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success('Save Success');
          setIsLoading(false);
          setButtonDisabled(false);
          handleResetFormValues();
          getDeliveryItems();
          if (getSchedulerData) {
            getSchedulerData();
          }
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  function onCloseModal() {
    setIsLoading(false);
    handleResetFormValues();
    setSelectedDeliveryItem(null);
    setShow(false);
  }

  return (
    <>
      <Modal show={show} size='2xl' onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <div className='w-full'>
                <div className='mx-1 flex items-end justify-center'>
                  <div className='flex flex-1 justify-center'>
                    <h1 className='text-gray-900 font-bold text-4xl'>
                      {selectedDeliveryItem ? 'Edit' : 'Add'} Item
                    </h1>
                  </div>
                </div>
              </div>
              <div>
                <div className='container mx-auto p-2'>
                  <div className='md:flex no-wrap md:-mx-2 '>
                    <div className='w-full'>
                      <div className='bg-white'>
                        <hr className='bg-gray-300 h-[5px]'></hr>
                        <form id='DeliveryItemForm' onSubmit={onSubmit}>
                          <div className='text-gray-500'>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Location Asset:
                                </div>
                              </div>
                              <div className='w-full flex'>
                                <Select
                                  id='clientLocationAssetId'
                                  name='clientLocationAssetId'
                                  value={
                                    options
                                      ? options.find(
                                          (x) =>
                                            x.value ===
                                            formData.clientLocationAssetId
                                        )
                                      : ''
                                  }
                                  onChange={handleChangeSelect}
                                  isSearchable
                                  options={options}
                                  required
                                  styles={customStyles}
                                ></Select>
                                {locationId > 0 && (
                                  <div className='content-center pl-2'>
                                    <Button
                                      onClick={() =>
                                        setshowAddNewLocationAssetModal(true)
                                      }
                                      className='buttonMain'
                                    >
                                      <HiPlus size={12} />
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </div>
                            <hr className='bg-gray-300 h-[2px]'></hr>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Item:
                                </div>
                              </div>
                              <div className='w-full'>
                                <Select
                                  id='inventoryTypeId'
                                  name='inventoryTypeId'
                                  onChange={handleChangeSelectItem}
                                  value={
                                    inventoryListOptions
                                      ? inventoryListOptions.find(
                                          (x) =>
                                            x.value === formData.inventoryTypeId
                                        )
                                      : ''
                                  }
                                  required
                                  options={inventoryListOptions}
                                  styles={customStyles}
                                ></Select>
                              </div>
                            </div>
                            <hr className='bg-gray-300 h-[2px]'></hr>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  Fuel QTY:
                                </div>
                              </div>
                              <div className='w-full'>
                                <TextInput
                                  id='quantity'
                                  name='quantity'
                                  type='text'
                                  onChange={handleChangeInput}
                                  value={formData.quantity ?? ''}
                                  sizing='md'
                                />
                              </div>
                            </div>
                            <hr className='bg-gray-300 h-[2px]'></hr>
                            <div className='grid grid-cols-[35%_65%] text-xl'>
                              <div className='flex'>
                                <div className='font-bold content-center'>
                                  DEF QTY:
                                </div>
                              </div>
                              <div className='w-full'>
                                <TextInput
                                  id='defQuantity'
                                  name='defQuantity'
                                  type='text'
                                  onChange={handleChangeInput}
                                  value={formData.defQuantity ?? ''}
                                  sizing='md'
                                />
                              </div>
                            </div>
                          </div>
                          <div className='flex justify-end pt-2'>
                            <Button
                              disabled={buttonDisabled}
                              type='submit'
                              className='buttonMain'
                              form='DeliveryItemForm'
                            >
                              Save
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ClientLocationAssetModal
        show={showAddNewLocationAssetModal}
        setShow={setshowAddNewLocationAssetModal}
        clientLocationId={locationId}
        getAssetsForClientLocation={getAssetsForClientLocation}
        selectedClientLocationAsset={null}
      />
    </>
  );
}
